import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import genericSupplierClient from 'Services/Apis/Spot/genericSupplierClient';
import redemptionsApiClient from 'Services/Apis/Spot/redemptionsClient';

const initialState = {
  isVisibleDifal: false,
  isVisibleModalDifalTerms: false,
  createPDF: null,
  isLoadingPDF: false,
  isLoadingSpot: false,
  isErrorSpot: false,
  isValidToCheckout: true,
  quote: null,
  termUrl: null,
  dataSpot: {},
  addressBilling: null,
  addressShipping: null,
};

export const loadDataQuote = createAsyncThunk(
  `approveQuotation/loadDataQuote`,
  async (payload, { getState }) => {
    const { address } = getState().Participants;
    const { data } = await redemptionsApiClient.get(
      `/Redemption/${payload.redemptionId}`,
      {
        headers: payload.headers,
      }
    );

    return {
      ...data,
      address: address,
    };
  }
);

export const loadUserQuote = createAsyncThunk(
  'approveQuotation/loadUserQuote',
  async (payload) => {
    const { data: dataUsername } = await redemptionsApiClient.get(
      `/Participant/${payload.participantId}`,
      {
        headers: payload.headers,
      }
    );

    const { data: dataSubSegmento } = await genericSupplierClient.get(
      `/api/ParticipantGroup?participantId=${payload.participantId}`,
      {
        headers: payload.headers,
      }
    );

    const { data: dataBalance } = await redemptionsApiClient.get(
      `/Participant/balance?participantId=${payload.participantId}&username=${dataUsername.username}`,
      {
        headers: payload.headers,
      }
    );

    return {
      dadosUsuario: dataUsername,
      dadosCarteira: dataBalance,
      dadosSubSegmento: dataSubSegmento,
    };
  }
);

const approveQuotation = createSlice({
  name: 'approveQuotation',
  initialState: initialState,
  reducers: {
    setIsVisibleDifalModal(state, action) {
      state.isVisibleModalDifalTerms = action.payload;
    },
    setTermUrl(state, action) {
      state.termUrl = action.payload;
    },
    setIsValidToCheckout(state, action) {
      state.isValidToCheckout = action.payload;
    },

    setAddressBilling(state, action) {
      state.addressBilling = {
        zipCode: action.payload.subEnderecoEntregaCep,
        address: action.payload.subEnderecoEntregaRua,
        complement: action.payload.subEnderecoEntregaComplemento,
        neighborhood: action.payload.subEnderecoEntregaBairro,
        city: action.payload.subEnderecoEntregaCidade,
        number: action.payload.subEnderecoEntregaNumero,
        state: action.payload.subEnderecoEntregaEstado,
      };
    },
    setAddressShipping(state, action) {
      state.addressShipping = action.payload;
    },
  },

  extraReducers: (builder) => {
    builder.addCase(loadUserQuote.pending, (state, action) => {
      state.isLoadingPDF = true;
    });

    builder.addCase(loadUserQuote.fulfilled, (state, action) => {
      state.createPDF = {
        ...action.payload.dadosUsuario,
        ...action.payload.dadosCarteira,
        ...action.payload.dadosSubSegmento,
      };
      state.isLoadingPDF = false;
    });
    builder.addCase(loadUserQuote.rejected, (state, action) => {
      console.log('loadUserInfos.rejected', action);
    });

    builder.addCase(loadDataQuote.pending, (state, action) => {
      state.isLoadingSpot = true;
      state.isErrorSpot = false;
    });
    builder.addCase(loadDataQuote.fulfilled, (state, action) => {
      state.dataSpot = action.payload;
      state.quote = action.payload?.files[0];
      state.isLoadingSpot = false;
      state.addressShipping = {
        zipCode: action.payload.address['zipCode'].value,
        address: action.payload.address['addressText'].value,
        complement: action.payload.address['complement'].value,
        neighborhood: action.payload.address['district'].value,
        city: action.payload.address['city'].value,
        number: action.payload.address['number'].value,
        state: action.payload.address['state'].value,
      };
    });
    builder.addCase(loadDataQuote.rejected, (state, action) => {
      console.log('loadDataSpot.rejected', action);
      state.isErrorSpot = true;
    });
  },
});

export const {
  setIsVisibleDifalModal,
  setTermUrl,
  setIsValidToCheckout,
  setAddressBilling,
  setAddressShipping,
} = approveQuotation.actions;
export default approveQuotation.reducer;
